/**
 * The SDP for the local end of the connection.
 * @method getLocalDescription
 */
export default function getLocalDescription () {
  const { nativePeer, log } = this
  log.info('Getting local description.')

  const localDesc = nativePeer.localDescription
  /*
   * Ensure it is a RTCSessionDescription object.
   * In some scenarios (based on browser?), it may return an empty object
   *    instead of undefined when there is no local description.
   * TODO: Determine if this is still needed, or if we can use the native
   *    property directly.
   */
  if (localDesc && localDesc.sdp && localDesc.type) {
    return localDesc
  } else {
    return undefined
  }
}
